import { CONTACT_INFO } from '../utils/constants';
import { IconWhatsapp } from '../utils/icons';

const WhatsappButton = () => {
    return (
        <a
            className='whatsapp-fab'
            href={CONTACT_INFO.whatsappLink}
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Chat on WhatsApp'
        >
            <IconWhatsapp size={30} />
        </a>
    );
};

export default WhatsappButton;
